import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import VisitForm from "@/pages/VisitForm";
import VisitDetail from "@/pages/VisitDetail";
import AdminMeasures from "@/pages/AdminMeasures";
import AdminInstallers from "@/pages/AdminInstallers";
import AdminUsers from "@/pages/AdminUsers";
import Verify from "@/pages/Verify";
import Governance from "@/pages/Governance";

const wrap = (el, adminOnly = false) => (
  <ProtectedRoute adminOnly={adminOnly}>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/verify/:id" element={<Verify />} />
            <Route path="/" element={wrap(<Dashboard />)} />
            <Route path="/visits/new" element={wrap(<VisitForm />)} />
            <Route path="/visits/:id/edit" element={wrap(<VisitForm />)} />
            <Route path="/visits/:id" element={wrap(<VisitDetail />)} />
            <Route path="/measures" element={wrap(<AdminMeasures />, true)} />
            <Route path="/installers" element={wrap(<AdminInstallers />, true)} />
            <Route path="/users" element={wrap(<AdminUsers />, true)} />
            <Route path="/governance" element={wrap(<Governance />, true)} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
